export const rupiah = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export const rupiahShort = (n) => {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1000000) return "Rp " + (v / 1000000).toFixed(1).replace(".", ",") + " jt";
  if (Math.abs(v) >= 1000) return "Rp " + Math.round(v / 1000) + "rb";
  return "Rp " + Math.round(v);
};

export const formatNumber = (n) => (Number(n) || 0).toLocaleString("id-ID");
